import { Component, OnInit } from '@angular/core';
import { LayoutService } from 'src/app/layout/layout.service';

@Component({
  selector: 'app-service-near-contact-us',
  templateUrl: './service-near-contact-us.component.html',
  styleUrls: ['./service-near-contact-us.component.scss']
})
export class ServiceNearContactUsComponent implements OnInit{

  // for tost msg
  notificationMsg = '';
  showToast: boolean = false;
  isSuccess: boolean;

  constructor( public layoutService: LayoutService) {}

  ngOnInit(): void {
    this.populateToolbarData();
  }

  private populateToolbarData() {
    this.layoutService.setToolbar({
      title: 'Contact Us',
    });

    this.layoutService.setNavbarButtons([]);
  }

  private notify(status: boolean, msg: string) {
    this.showToast = true;
    this.isSuccess = status;
    this.notificationMsg = msg;
    setTimeout(() => {
      this.showToast = false;
    }, 2000);
  }

  callNumber(number: string) {
    if (number) {
      window.location.href = `tel:${number}`;
    } else {
      console.warn('No phone number provided');
      this.notify(false, 'No phone number provided');
    }
  }

  openYoutube() {
    window.open(
      'https://youtube.com/playlist?list=PLcWdOeOoSgudCbOaSRv295JoyAibjUUQR&si=g3LV2dUcsFy7IEp_',
      '_blank'
    );
  }

  openWhatsApp(phone: string) {
    const url = `https://wa.me/${phone}`;
    window.open(url, '_blank');
  }
}
